module.exports = __webpack_public_path__ + "../static/img/banner_sada.4dd3603c.jpg";